import { Menu, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
const PhoneMenu = styled(Menu)`
  &&.MuiModal-root {
    z-index: 1305;
  }

  &&.MuiMenu-paper {
    z-index: 2001;
  }
`;
const PhoneItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.grey[800],
  "&:hover": {
    backgroundColor: theme.palette.primary[50]
  }
}));
export {
  PhoneItem,
  PhoneMenu
};
